// @flow
/** @jsx h */

import { h, Component } from 'preact'

type Props = {
  type: 'assertive',
  children: any,
}

export class AriaLive extends Component<Props> {
  render () {
    return (
      <div id='ariaLive' className='nrk-sr' aria-live={this.props.type}>
        {this.props.children}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/shared/widgets/LivePoll/components/LivePoll/AriaLive/AriaLive.js